import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import * as ACT from 'components/Company/actions'
import { ContactRow } from './ContactRow'
import { FaUsers, FaPlusCircle } from 'react-icons/fa'
import { ContactModalContainer } from 'components/common/modals/ContactModalContainer'
import { AddButton } from 'components/common/AddButton'
import s from './ContactsSection.scss'

const selectContacts = createSelector([state => state.company], company => {
  return company.contacts
})

const ContactsSection = ({ companyId, companyName }) => {
  const [showContactModal, setShowContactModal] = useState(false)

  const dispatch = useDispatch()

  const contacts = useSelector(state => selectContacts(state))

  useEffect(() => {
    companyId &&
      dispatch({
        type: ACT.COMPANY_CONTACTS_FETCH_REQUESTED,
        payload: {
          id: companyId
        }
      })
  }, [companyId, dispatch])

  const toggleContactModal = () => {
    setShowContactModal(!showContactModal)
  }

  const currentCompany = {
    value: companyId,
    label: companyName
  }

  return (
    <section className={s.contactsContainer}>
      <div className={s.contactsTitle}>
        <FaUsers />
        Contacts from this Company
      </div>
      <AddButton className={s.addBtn} onClick={toggleContactModal}>
        <FaPlusCircle />
        Add Contact
      </AddButton>
      <ContactModalContainer
        toggleContactModal={toggleContactModal}
        showContactModal={showContactModal}
        actionType={ACT.CONTACT_CREATE_REQUESTED}
        currentCompany={currentCompany}
      />
      {contacts.map(contact => (
        <ContactRow contact={contact} key={contact.id} />
      ))}
    </section>
  )
}

export default ContactsSection
